import { CreateStageRequestCloudProviderEnum, CreateStageRequestInfrastructureAsCodeToolEnum } from "@microtica/ms-engine-sdk";
import { Button, Card, Col, Divider, Form, Input, notification, Row } from "antd";
import { RequiredMark } from "antd/lib/form/Form";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import { getEnvironmentService } from "../backend";
import { trackEnvCreateFailed, trackEnvCreateSucceeded } from "../backend/tracking/environment";
import { currentProjectState } from "../recoil/project";

interface CreateEnvironmentProps {
    onSuccessfullyCreatedStage: Function;
}
const CreateEnvironment = ({
    onSuccessfullyCreatedStage
}: CreateEnvironmentProps) => {
    const currentProject = useRecoilValue(currentProjectState);
    const [creatingEnv, setCreatingEnv] = useState(false);
    const [requiredMark] = useState<RequiredMark>('optional');
    const [form] = Form.useForm();

    const handleCreateEnvironment = async (values: { name: string, description: string }) => {
        try {
            setCreatingEnv(true);
            const { data: { id } } = await getEnvironmentService().createStage(
                currentProject!.id,
                {
                    name: values.name,
                    description: values.description,
                    cloudProvider: CreateStageRequestCloudProviderEnum.Aws,
                    infrastructureAsCodeTool: CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation
                });

            await onSuccessfullyCreatedStage();
            notification.success({ message: "New environment created" });
            trackEnvCreateSucceeded(
                id,
                values.name,
                CreateStageRequestCloudProviderEnum.Aws,
                CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation,
                false
            );
        } catch (error: any) {
            notification.error({
                message: "Cannot create new environment",
                description: error.response.data.message
            });
            trackEnvCreateFailed(
                values.name,
                CreateStageRequestCloudProviderEnum.Aws,
                CreateStageRequestInfrastructureAsCodeToolEnum.Cloudformation,
                false,
                error.response.data.message
            );
        } finally {
            setCreatingEnv(false);
        }
    }

    return (
        <Card>
            <Card.Meta
                title="Create New Environment"
                description="Environments help you separate your development and production apps."
            />
            <Divider />
            <Form
                form={form}
                layout="vertical"
                initialValues={{}}
                onFinish={handleCreateEnvironment}
                requiredMark={requiredMark}
            >
                <Row gutter={12}>
                    <Col span={12}>
                        <Form.Item
                            name="name"
                            label="Name"
                            required
                            rules={[{ required: true, message: 'Please input environment name!' }]}
                        >
                            <Input placeholder="development" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="description"
                            label="Description"
                            required
                            rules={[{ required: true, message: 'Please input environment description!' }]}
                        >
                            <Input placeholder="My development environment" maxLength={100} showCount />
                        </Form.Item>
                    </Col>
                </Row>
                <br />
                <Button type="primary" htmlType="submit" style={{ float: "right" }} loading={creatingEnv}>
                    Create
                </Button>
            </Form>
        </Card>
    )
}

export default CreateEnvironment;